import SEO from "@/components/SEO";
import { PageHero, Section, SectionHead, FAQ } from "@/components/sections";
import { Reveal } from "@/components/Reveal";
import { CTALink } from "@/components/ui-kit";
import LeadForm from "@/components/LeadForm";

const rows = [
  { label: "What it is", mf: "Pooled fund managed to a scheme mandate", pms: "Individually-managed portfolio of securities", aif: "Pooled alternative fund (Cat I/II/III)" },
  { label: "Minimum investment", mf: "As low as ₹500 (SIP)", pms: "₹50,00,000 (SEBI)", aif: "₹1,00,00,000 (SEBI)" },
  { label: "Structure", mf: "Units in a trust", pms: "Securities held in your demat", aif: "Units in a trust / LLP" },
  { label: "Regulator", mf: "SEBI (MF Regulations)", pms: "SEBI (PMS Regulations)", aif: "SEBI (AIF Regulations)" },
  { label: "Ideal investor", mf: "All investors, goal-based", pms: "HNIs seeking customisation", aif: "HNIs seeking alternatives" },
  { label: "Liquidity", mf: "High (open-ended)", pms: "Moderate", aif: "Lower / lock-in common" },
];

const faq = [
  { q: "Which is right for me?", a: "It depends on your investable surplus, goals and risk appetite. Most investors start with mutual funds; PMS and AIF suit eligible HNIs seeking customisation or alternatives." },
  { q: "Are PMS and AIF riskier than mutual funds?", a: "They can carry higher concentration and liquidity risk and are meant for informed, eligible investors. All are subject to market risk; nothing is guaranteed." },
  { q: "Do you help with documentation and onboarding?", a: "Yes — we guide KYC, suitability and onboarding for each structure and keep you compliant throughout." },
];

export default function MFPMSAIF() {
  return (
    <div>
      <SEO path="/products/mf-pms-aif" title="MF, PMS & AIF" description="Understand mutual funds, PMS and AIF — structure, minimums (PMS ₹50L, AIF ₹1Cr), regulator and liquidity compared. Guidance from Rao Investment Solutions." faq={faq} />
      <PageHero
        label="Products"
        title="Mutual Funds, PMS & AIF"
        intro="Three ways to invest in market-linked strategies — with very different minimums, structures and suitability. Here's how they compare."
        breadcrumbs={[{ name: "Home", to: "/" }, { name: "Products" }, { name: "MF, PMS & AIF" }]}
      />

      <Section className="!pt-0">
        <Reveal>
          <div className="overflow-x-auto border border-navy/10 bg-white">
            <table className="w-full border-collapse min-w-[720px]" data-testid="comparison-table">
              <thead>
                <tr className="border-b border-navy/10">
                  <th className="text-left font-sans text-xs uppercase tracking-[0.18em] text-slate p-5"> </th>
                  <th className="text-left font-serif text-xl text-navy p-5">Mutual Funds</th>
                  <th className="text-left font-serif text-xl text-navy p-5">PMS</th>
                  <th className="text-left font-serif text-xl text-navy p-5">AIF</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i} className="border-b border-navy/5 last:border-0">
                    <td className="p-5 font-sans text-xs uppercase tracking-[0.14em] text-slate">{r.label}</td>
                    <td className="p-5 font-data text-sm text-offblack">{r.mf}</td>
                    <td className="p-5 font-data text-sm text-offblack">{r.pms}</td>
                    <td className="p-5 font-data text-sm text-offblack">{r.aif}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
        <p className="mt-4 font-data text-xs text-slate">Minimums per SEBI regulations. Figures illustrative; confirm current thresholds at onboarding. Investments are subject to market risk.</p>
      </Section>

      <Section cream>
        <div className="max-w-3xl"><SectionHead label="FAQ" title="Common questions" /><FAQ items={faq} /></div>
        <div className="mt-10 flex flex-wrap gap-4">
          <CTALink to="/calculators" variant="secondary" data-testid="mf-calc-cta">Try the MF calculator</CTALink>
          <CTALink to="/contact" variant="primary" data-testid="mf-contact-cta">Discuss suitability</CTALink>
        </div>
      </Section>

      <Section dark>
        <div className="grid lg:grid-cols-2 gap-14 items-start">
          <SectionHead label="Next step" title="Find the structure that fits you." dark intro="We'll assess eligibility, suitability and goals before suggesting anything." />
          <div className="bg-white/5 border border-white/10 p-8 md:p-10"><LeadForm dark interest="MF / PMS / AIF" title="Request guidance" /></div>
        </div>
      </Section>
    </div>
  );
}
